import React, { FC, useMemo, useRef } from 'react';

import { MdGroupAdd } from 'react-icons/md';

import { Button, Flex, Heading } from '@chakra-ui/react';

import { UserPill } from 'components/core/UserPill';
import { DataTable } from 'components/modules/DataTable';
import { EditGroupModal } from 'components/modules/EditGroupModal';
import { AddGroupModal, RefType } from 'components/modules/AddGroupModal';
import { washHub } from 'store/slices';
import { Group } from 'types/groups';
import { GroupsViewProps } from './Groups.props';

import { buildGroupColumns } from './groupsColumns';

const GroupsView: FC<GroupsViewProps> = ({ groups, isLoading, pagination }) => {
  const addGroupModalRef = useRef<RefType>(null);
  const editGroupModalRef = useRef<any>(null);
  const selectedWashHubId = washHub.selectors.useSelectedWashHubId();

  const columns = useMemo(() => buildGroupColumns(), []);

  return (
    <Flex flex={1} direction="column" color="support.500" overflow="auto">
      <Flex alignItems="baseline" justify="space-between">
        <Heading mb={6} fontSize="24px">
          Groups
        </Heading>
        <Flex align="flex-end">
          <Button
            isDisabled={selectedWashHubId === ''}
            mr={2}
            minW="200px"
            leftIcon={<MdGroupAdd size="20px" />}
            onClick={() => {
              addGroupModalRef.current?.onOpen?.();
            }}>
            Create Group
          </Button>
          <UserPill />
        </Flex>
      </Flex>
      <Flex h="50px" />
      <DataTable<Group>
        minW="1200px"
        data={groups}
        columns={columns}
        isLoading={isLoading}
        pagination={pagination}
        onRowClick={(group) => {
          editGroupModalRef?.current?.onOpen(group);
        }}
      />
      <AddGroupModal ref={addGroupModalRef} />
      <EditGroupModal ref={editGroupModalRef} />
    </Flex>
  );
};

export default GroupsView;
